<template>
  <a-card>
    <a-descriptions :column="2">
      <div slot="title">
        Info Form / Thông tin nghỉ phép
      </div>
      <a-descriptions-item label="Employee code / Mã Nhân Viên">
        {{ workLeave.employee && workLeave.employee.code }}
      </a-descriptions-item>
      <a-descriptions-item label="Employee / Nhân Viên">
        {{ workLeave.employee && workLeave.employee.fullname }}
      </a-descriptions-item>
      <a-descriptions-item label="Department / Phòng ban">
        {{
          workLeave.employee &&
          workLeave.employee.department &&
          workLeave.employee.department.name
        }}
      </a-descriptions-item>
      <a-descriptions-item label="Position / Chức vụ">
        {{
          workLeave.employee &&
          workLeave.employee.position &&
          workLeave.employee.position.name
        }}
      </a-descriptions-item>
      <a-descriptions-item label="Type Leave / Loại nghỉ phép" :span="2">
        {{ workLeave.typeWorkLeave && workLeave.typeWorkLeave.title }}
      </a-descriptions-item>
      <a-descriptions-item label="Shift / Ca làm việc" :span="2">
        <span v-if="workLeave.workShift">
          {{ workLeave.workShift.code }} - {{ workLeave.workShift.title }}
        </span>
      </a-descriptions-item>
      <a-descriptions-item label="Total Leave Hour / Số giờ nghỉ">
        {{ workLeave.totalLeaveHours }}
      </a-descriptions-item>
    </a-descriptions>
    <section class="highlight-wrapper">
      <p style="color: #777; font-size: 15px;">
        Content / Nội dung
        <a-button
          v-if="isEditting"
          @click="
            () => {
              form.description = workLeave.description;
              visible = true;
            }
          "
          type="link"
          icon="edit"
          style="float: right;"
        ></a-button>
      </p>
      <br />
      <div v-if="!visible">
        <p
          v-if="workLeave.description"
          class="top-descriptions ql-editor"
          v-html="workLeave.description"
          style="padding: 0px;"
        ></p>
      </div>

      <div v-else>
        <VueEditor
          class="ict24h-editor"
          :editor-toolbar="customToolbar"
          v-model="form.description"
          placeholder="Nhập nội dung..."
        />
        <div style="text-align: right; margin-top: 10px;">
          <a-button @click="() => (visible = false)" style="margin-right: 5px;">
            Close
          </a-button>
          <a-button
            :loading="loading"
            icon="save"
            type="primary"
            @click="saveData"
          >
            Update
          </a-button>
        </div>
      </div>
    </section>
  </a-card>
</template>
<script>
import query from "../../constant/query";
const customToolbar = [
  [{ header: [false, 1, 2, 3, 4, 5, 6] }],
  ["bold", "italic", "underline", "strike"],
  [{ list: "ordered" }, { list: "bullet" }, { list: "check" }],
  ["blockquote"],
  [{ indent: "-1" }, { indent: "+1" }], // outdent/indent
  [{ color: [] }, { background: [] }], // dropdown with defaults from theme
  [
    { align: "" },
    { align: "center" },
    { align: "right" },
    { align: "justify" },
  ],
  ["clean"], // remove formatting button
];
export default {
  props: {
    workLeave: {
      type: Object,
      required: true,
    },
    refreshAfterUpdated: {
      type: Function,
      default: () => {},
    },
    isEditting: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return { customToolbar, visible: false, form: {}, loading: false };
  },
  methods: {
    collapseModal() {
      this.$set(this.form, "description", this.workLeave.description);
      this.visible = !this.visible;
    },
    saveData() {
      const vm = this;
      const { idWorkLeave } = this.$route.params;
      if (!idWorkLeave) {
        throw new Error("Cannot get id work leave in params");
      }
      this.loading = true;
      this.$apollo
        .mutate({
          mutation: query.updateWorkLeave,
          variables: {
            id: idWorkLeave,
            description: this.form.description ? this.form.description : null,
          },
        })
        .then(({ data }) => {
          this.loading = false;
          if (data?.updateWorkLeave) {
            this.refreshAfterUpdated(data.updateWorkLeave);
          }
          this.visible = false;
          this.$notification.success({
            message: "Thông báo",
            description: "Cần sửa nghỉ phép thành công!",
          });
        })
        .catch((err) => {
          this.loading = false;
          this.$notification.error({
            message: "Thông báo",
            description: "Cần sửa nghỉ phép không thành công!",
          });
          console.error("Không Cần sửa loại nghỉ phép", err);
        });
    },
  },
};
</script>
<style lang="css" scoped>
.top-descriptions {
  white-space: pre-line;
}
.highlight-wrapper {
  position: relative;
  border-radius: 0 0 2px 2px;
  border-top: 1px dashed #ebedf0;
  padding: 10px 0;
}
</style>
